export const sleep = (ms: number) =>
  new Promise<void>((resolve) => {
    setTimeout(resolve, ms);
  });

export const ensureMinDuration = async (startedAtMs: number, minMs: number) => {
  const elapsedMs = Date.now() - startedAtMs;
  if (elapsedMs < minMs) {
    await sleep(minMs - elapsedMs);
  }
};

